import React from 'react';
import MainLayout from '../layouts/MainLayout';
import { pageMeta } from '../lib/seo';
import { Mail, Phone, MapPin } from 'lucide-react';

const ImprintPage = () => {
  return (
    <MainLayout
      title={pageMeta.imprint.title}
      description={pageMeta.imprint.description}
      keywords={pageMeta.imprint.keywords}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl md:text-5xl font-bold text-primary-text-dark mb-8">
          Impressum
        </h1>

        <div className="prose prose-lg max-w-none">
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">
              Angaben gemäß § 5 TMG
            </h2>

            <div className="bg-white rounded-xl p-6 shadow-sm border border-primary-gray-border">
              <p className="text-primary-text-dark font-semibold text-lg mb-4">
                SENKAY Personal & Logistik
              </p>

              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-primary-blue-mid mt-1 flex-shrink-0" />
                  <div>
                    <p className="text-primary-text-dark mb-0">
                      Georg-Maurer-Weg 11<br />
                      80995 München<br />
                      Deutschland
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <Phone className="w-5 h-5 text-primary-blue-mid flex-shrink-0" />
                  <a href="tel:+491783620226" className="text-primary-blue-mid hover:underline">
                    +49178 3620226
                  </a>
                </div>

                <div className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 text-primary-blue-mid flex-shrink-0" />
                  <a href="mailto:kontakt@senkay-personallogistik.de" className="text-primary-blue-mid hover:underline">
                    kontakt@senkay-personallogistik.de
                  </a>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">
              Vertreten durch
            </h2>
            <p className="text-primary-text-muted leading-relaxed">
              Geschäftsführerin: Hilal Kaygisiz
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">
              Registereintrag
            </h2>
            <p className="text-primary-text-muted leading-relaxed mb-2">
              <strong>Eintragung im Handelsregister:</strong><br />
              Registergericht: Amtsgericht München<br />
              Registernummer: HRB XXXXXX
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">
              Umsatzsteuer-ID
            </h2>
            <p className="text-primary-text-muted leading-relaxed">
              <strong>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</strong><br />
              DE XXXXXXXXX
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">
              Erlaubnis zur Arbeitnehmerüberlassung
            </h2>
            <p className="text-primary-text-muted leading-relaxed">
              Erlaubnis zur Arbeitnehmerüberlassung gemäß § 1 AÜG<br />
              Erlaubnisnummer: XXXXXXXXX<br />
              Ausstellende Behörde: Agentur für Arbeit München
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p className="text-primary-text-muted leading-relaxed">
              Hilal Kaygisiz<br />
              Georg-Maurer-Weg 11<br />
              80995 München
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">
              Streitschlichtung
            </h2>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary-blue-mid hover:underline ml-1">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="text-primary-text-muted leading-relaxed">
              Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">
              Haftung für Inhalte
            </h2>
            <p className="text-primary-text-muted leading-relaxed mb-4">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
              forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="text-primary-text-muted leading-relaxed">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
              bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis
              einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden
              wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">
              Haftung für Links
            </h2>
            <p className="text-primary-text-muted leading-relaxed">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-primary-text-dark mb-4">
              Urheberrecht
            </h2>
            <p className="text-primary-text-muted leading-relaxed">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>

          <p className="text-primary-text-muted leading-relaxed">
            Gestaltung und technische Betreuung der Website:{' '}
            <a href="https://www.westkante.de/" className="underline hover:text-primary-text-dark">
              Westkante
            </a>
            , München.
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default ImprintPage;
